var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        "custom-class": "card-detail-dialog",
        "close-on-click-modal": false,
        "show-close": true,
      },
      on: {
        "update:visible": function ($event) {
          return _vm.$emit("update:visible", $event)
        },
      },
    },
    [
      _c("div", { staticClass: "dialog-header" }, [
        _c(
          "div",
          { staticClass: "parent-select" },
          [
            _c(
              "el-select",
              {
                attrs: { value: _vm.columnId, size: "mini" },
                on: {
                  change: function ($event) {
                    return _vm.$emit("column-switch", $event)
                  },
                },
              },
              _vm._l(_vm.columns, function (col) {
                return _c("el-option", {
                  key: col.id,
                  attrs: { label: col.title, value: col.id },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "tip red" }, [
          _vm._v(
            "(設定到期日、指定成員、留下敘述、勾選完成，公司成員可共同評論)"
          ),
        ]),
      ]),
      _vm.card
        ? _c("div", { staticClass: "dialog-content" }, [
            _c("div", { staticClass: "dialog-main" }, [
              _c("div", { staticClass: "detail-block" }, [
                _c(
                  "div",
                  { staticClass: "detail-title-section" },
                  [
                    _c("i", {
                      class: _vm.card.completed
                        ? "el-icon-success checked"
                        : "el-icon-circle-check unchecked",
                      on: {
                        click: function ($event) {
                          return _vm.$emit("toggle-check", _vm.card)
                        },
                      },
                    }),
                    _c("el-input", {
                      staticClass: "detail-title",
                      model: {
                        value: _vm.card.title,
                        callback: function ($$v) {
                          _vm.$set(_vm.card, "title", $$v)
                        },
                        expression: "card.title",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "detail-item-block" }, [
                  _c("h4", [_vm._v("到期日")]),
                  _c(
                    "div",
                    { staticClass: "date-picker-wrapper" },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "datetime",
                          placeholder: "選擇日期時間",
                          size: "mini",
                          format: "yyyy-MM-dd HH:mm:ss",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.card.dueDateTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.card, "dueDateTime", $$v)
                          },
                          expression: "card.dueDateTime",
                        },
                      }),
                      _vm.card.completed
                        ? _c(
                            "el-tag",
                            { attrs: { size: "mini", type: "success" } },
                            [_vm._v("完成")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "detail-item-block" }, [
                  _c("h4", [_vm._v("成員")]),
                  _c("div", { staticClass: "member-section" }, [
                    _c(
                      "div",
                      { staticClass: "member-list" },
                      [
                        _vm.card.members && _vm.card.members.length
                          ? _vm._l(_vm.card.members, function (member) {
                              return _c(
                                "el-dropdown",
                                {
                                  key: member.id,
                                  attrs: { trigger: "click" },
                                  on: {
                                    command: function (cmd) {
                                      return _vm.handleMemberCommand(
                                        cmd,
                                        member.id
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "member-avatar-tag" },
                                    [
                                      _c(
                                        "el-avatar",
                                        {
                                          attrs: {
                                            size: "small",
                                            src: _vm.getMember(member.id)
                                              .avatar,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.getMember(member.id).name
                                                  ? _vm
                                                      .getMember(member.id)
                                                      .name.charAt(0)
                                                  : "U"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "member-name" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getMember(member.id).name
                                            )
                                          ),
                                        ]
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-arrow-down el-icon--right",
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown",
                                    },
                                    [
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          staticStyle: { color: "#f56c6c" },
                                          attrs: {
                                            command: "remove",
                                            icon: "el-icon-delete",
                                          },
                                        },
                                        [_vm._v(" 從卡片移除 ")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            })
                          : _c("span", { staticClass: "no-member-text" }, [
                              _vm._v("尚無指定成員"),
                            ]),
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "bottom-start",
                              width: "240",
                              trigger: "click",
                            },
                            model: {
                              value: _vm.memberPopoverVisible,
                              callback: function ($$v) {
                                _vm.memberPopoverVisible = $$v
                              },
                              expression: "memberPopoverVisible",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "member-popover-content" },
                              [
                                _c("div", { staticClass: "popover-title" }, [
                                  _vm._v("成員清單"),
                                ]),
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      multiple: "",
                                      filterable: "",
                                      "value-key": "id",
                                      placeholder: "搜尋並勾選成員",
                                      size: "mini",
                                    },
                                    model: {
                                      value: _vm.card.members,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.card, "members", $$v)
                                      },
                                      expression: "card.members",
                                    },
                                  },
                                  _vm._l(_vm.memberOptions, function (user) {
                                    return _c(
                                      "el-option",
                                      {
                                        key: user.id,
                                        attrs: {
                                          label: user.name,
                                          value: {
                                            id: user.id,
                                            name: user.name,
                                            avatar: user.avatar,
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "member-option-item" },
                                          [
                                            _c(
                                              "el-avatar",
                                              {
                                                attrs: {
                                                  size: "small",
                                                  src: user.avatar,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    user.name
                                                      ? user.name.charAt(0)
                                                      : ""
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c("span", [
                                              _vm._v(_vm._s(user.name)),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("el-button", {
                              attrs: {
                                slot: "reference",
                                size: "mini",
                                icon: "el-icon-plus",
                                circle: "",
                                title: "新增/編輯成員",
                              },
                              slot: "reference",
                            }),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "detail-block" },
                [
                  _c("h4", [
                    _c("i", { staticClass: "el-icon-tickets" }),
                    _vm._v(" 描述"),
                  ]),
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "添加詳細描述...",
                    },
                    model: {
                      value: _vm.card.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.card, "description", $$v)
                      },
                      expression: "card.description",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "detail-block" }, [
                _c(
                  "div",
                  { staticClass: "section-header" },
                  [
                    _c("h4", [
                      _c("i", { staticClass: "el-icon-paperclip" }),
                      _vm._v(" 附件 "),
                      _c("span", { staticClass: "tip gray ml" }, [
                        _vm._v(" (可上傳最多5個檔案，每個檔案20MB以內) "),
                      ]),
                    ]),
                    _c(
                      "el-upload",
                      {
                        attrs: {
                          action: "#",
                          "auto-upload": false,
                          "show-file-list": false,
                          "on-change": _vm.handleFileUpload,
                          disabled:
                            (_vm.card.attachments &&
                              _vm.card.attachments.length >= 5) ||
                            _vm.isSaving,
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              icon: "el-icon-plus",
                              type: "primary",
                              plain: "",
                              disabled:
                                (_vm.card.attachments &&
                                  _vm.card.attachments.length >= 5) ||
                                _vm.isSaving,
                            },
                          },
                          [_vm._v(" 添加附件 ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.card.attachments && _vm.card.attachments.length
                  ? _c(
                      "div",
                      { staticClass: "attachment-list" },
                      _vm._l(_vm.card.attachments, function (file, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "attachment-card" },
                          [
                            _c("div", { staticClass: "attachment-preview" }, [
                              _vm.isImage(file.name)
                                ? _c("img", {
                                    staticClass: "preview-img",
                                    attrs: {
                                      src: file.url || _vm.defaultImg,
                                      alt: file.name,
                                    },
                                  })
                                : _c("div", { staticClass: "file-icon-box" }, [
                                    _c("i", {
                                      class: _vm.getFileIcon(file.name),
                                    }),
                                  ]),
                            ]),
                            _c("div", { staticClass: "attachment-info" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "attachment-name",
                                  attrs: { title: file.name },
                                },
                                [_vm._v(_vm._s(file.name))]
                              ),
                              _c("div", { staticClass: "attachment-meta" }, [
                                _c("span", [_vm._v("已添加")]),
                                file.createTime
                                  ? _c(
                                      "span",
                                      { staticClass: "dot-separator" },
                                      [_vm._v("•")]
                                    )
                                  : _vm._e(),
                                _c("span", [_vm._v(_vm._s(file.createTime))]),
                                file.size
                                  ? _c(
                                      "span",
                                      { staticClass: "dot-separator" },
                                      [_vm._v("•")]
                                    )
                                  : _vm._e(),
                                file.size
                                  ? _c("span", [
                                      _vm._v(_vm._s(file.size) + " MB"),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]),
                            _c(
                              "div",
                              { staticClass: "attachment-actions" },
                              [
                                _c(
                                  "el-dropdown",
                                  {
                                    attrs: {
                                      trigger: "click",
                                      disabled: _vm.isSaving,
                                    },
                                    on: {
                                      command: function (cmd) {
                                        return _vm.handleAttachmentCommand(
                                          cmd,
                                          index,
                                          file
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "action-more-btn",
                                        attrs: { size: "mini", type: "text" },
                                      },
                                      [_c("i", { staticClass: "el-icon-more" })]
                                    ),
                                    _c(
                                      "el-dropdown-menu",
                                      {
                                        attrs: { slot: "dropdown" },
                                        slot: "dropdown",
                                      },
                                      [
                                        _c(
                                          "el-dropdown-item",
                                          {
                                            attrs: {
                                              command: "download",
                                              icon: "el-icon-download",
                                            },
                                          },
                                          [_vm._v("下載檔案")]
                                        ),
                                        _c(
                                          "el-dropdown-item",
                                          {
                                            staticStyle: { color: "#f56c6c" },
                                            attrs: {
                                              command: "delete",
                                              icon: "el-icon-delete",
                                            },
                                          },
                                          [_vm._v("刪除附件")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _c("div", { staticClass: "no-attachment-text" }, [
                      _vm._v("尚無上傳附件"),
                    ]),
              ]),
            ]),
            _c("div", { staticClass: "dialog-sidebar" }, [
              _c(
                "div",
                [
                  _c(
                    "h4",
                    { staticStyle: { margin: "0", "margin-bottom": "1rem" } },
                    [
                      _c("i", { staticClass: "el-icon-chat-dot-square" }),
                      _vm._v(" 評論和活動 "),
                    ]
                  ),
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      placeholder: "添加評論...",
                    },
                    model: {
                      value: _vm.newComment,
                      callback: function ($$v) {
                        _vm.newComment = $$v
                      },
                      expression: "newComment",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-top": "8px", width: "60px" },
                      attrs: {
                        size: "mini",
                        type: "primary",
                        disabled: _vm.isSaving,
                      },
                      on: { click: _vm.addComment },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
              _c("div", { staticStyle: { flex: "2", overflow: "auto" } }, [
                _c(
                  "div",
                  { staticClass: "activity-list" },
                  _vm._l(_vm.card.activities, function (act, idx) {
                    return _c(
                      "div",
                      { key: idx, staticClass: "activity-item" },
                      [
                        _c("div", { staticClass: "activity-content" }, [
                          _c(
                            "div",
                            { staticClass: "activity-content-title" },
                            [
                              _c("el-avatar", { attrs: { size: "small" } }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      act.userName ? act.userName.charAt(0) : ""
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("div", [_vm._v(_vm._s(act.userName))]),
                              _c("div", { staticClass: "time" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.showCommentTime(act.createTime)
                                    ) +
                                    " "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "activity-content-text" }, [
                            _vm._v(_vm._s(act.content)),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }